import React, { useState } from "react"
import { graphql } from "gatsby"
import Link from "gatsby-link"
import SEO from "../components/seo"
import Header from "../components/Header";
import Footer from "../components/Footer";
import PageWrapper from "../PageWrapper";
import heroSvg from '../img/undraw/undraw_mail_2_tqip.svg';
import chatSvg from '../img/undraw/undraw_chat_1wo5.svg';
import { useFormik } from 'formik';

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
/*
function serializeForm(form) {

	// Setup our serialized data
	var serialized = [];

	// Loop through each field in the form
	for (var i = 0; i < form.elements.length; i++) {

		var field = form.elements[i];

		// Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
		if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

		// If a multi-select, get all selections
		if (field.type === 'select-multiple') {
			for (var n = 0; n < field.options.length; n++) {
				if (!field.options[n].selected) continue;
				serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
			}
		}

		// Convert field data to a query string
		else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
			serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
		}
	}

	return serialized.join('&');

}
*/

function encode( data ){
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
}

function Hero({ bgImage }){

    return (

        <>
            <div className="header-hero bg_cover d-lg-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="header-hero-content">
                                <h1 className="hero-title">CONTACT US<br/>&amp;<b> STAY IN TOUCH</b></h1>
                                <h2 className="hero-subtitle mt-3 text-center text-lg-left">
                                    <span>Leave a message.</span> <span>Subscribe to our newsletter.</span> 
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="header-hero-image d-flex align-items-center">
                    <div className="image">
                        <img src={bgImage} alt="" />
                    </div>
                </div>
            </div>
        </>

    );

}

//                     { data, location }
const ContactIndex = ( { data } ) => {

    const [ hasAccepted, setHasAccepted ] = useState( false );
    const [ response, setResponse ] = useState({
        show: false,
        class: "",
        message: ""
    });

    const formik = useFormik({
        validateOnMount: true,
        initialValues: {
            name: "",
            email: "",
            message: ""
        },
        onSubmit: (values, { resetForm }) =>{

            console.log( "Submitting message..." );

            fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: encode({ "form-name": "contact-form", ...values })
              })
                .then(( response ) => {

                    if ( response.ok && response.status === 200 ){

                        resetForm();
                        setResponse({ show: true, class: "success", message: "Thank you! Your message has been received." });

                    } else {

                        throw new Error("Form submission failed");

                    }

                })
                .catch(error => {

                    console.log( "Error:", error );
                    setResponse({ 
                        show: true,
                        class: "danger",
                        message: "Something went wrong. Please try again." 
                    });

                });
        
        },
        validate: values => {

            let errors = {}

            if ( !values.name ){
                errors.name = "Required";
            }
            if ( !values.email ){
                errors.email = "Required";
            } 

            if ( !values.message ){
                errors.message = "Required";
            }

            return errors;

        }
    });

    const newsLetterFormik = useFormik({
        initialValues: {
            email: ""
        },
        onSubmit: ( values, { resetForm } )=>{

            console.log( "Submitting Newsletter..." );

            fetch("/", {
                method: "POST",
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: encode({ "form-name": "newsletter-form", ...values, "Request-Type" : "Newsletter Subscription" })
              })
                .then(( response ) => {

                    if ( response.ok && response.status === 200 ){

                        resetForm();
                        setResponse({ show: true, class: "success", message: "Thank you! Your Newsletter request has been received." });

                    } else {

                        throw new Error("Newsletter form submission failed");

                    }

                })
                .catch(error => {

                    console.log( "Error:", error );
                    setResponse({ 
                        show: true,
                        class: "danger",
                        message: "Something went wrong. Please try again." 
                    });

            });

        },
        validate: values =>{
            let errors = {}
            if ( !values.email ){
                errors.email = "Required";
            } 
            return errors;
        }
    })

    const siteTitle = data.site.siteMetadata.title;
    const disabledStyle = {
        opacity: 0.3,
        backgroundColor: "gray !important"
    }

    const handleAcceptedChange = e =>{
        setHasAccepted( e.target.checked );
        console.log( hasAccepted );
    }

    /* eslint no-unused-vars: 0 */
    /*
    const handleSubmit = e => {
        console.log("handleSubmit()");
        e.preventDefault();
        const postURL = e.target.getAttribute("action");
        const serializedForm = serializeForm( e.target );
        console.log( serializedForm );
        fetch( postURL, {
            method: 'POST',
            body: serializeForm
        })
        .then( res => res.text() )
        .then( data => console.log("DATA:", data) )
        .catch( err => console.log("ERROR:", err) );
        return false;
        // e.target.submit();
    }
    */

    return (
        <PageWrapper>
            <Header component={ <Hero bgImage={ heroSvg } /> } title={ siteTitle } />
            <SEO title="Contact Us - lexiQA" />
            <SEO description="Get in touch to see how we can help you simplify your translation quality management" />

            {/* <!--====== CONTACT PART START ======--> */}

            <section className="contact-area pt-120 pb-120 bg-light">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5 px-5">
                            <p className="mb-3">
                            We welcome requests for information from translation buyers and translation technology providers (and also LSPs using exclusively cloud-based CAT tools).
                            </p>
                            <p className="p-5">
                                <img src={chatSvg} alt="" />
                            </p>
                            <p className="font-weight-bold text-center text-lg-left">
                            Please note that lexiQA’s software is not available to freelancers.
                            </p>
                        </div>
                        <div className="col-lg-7">
                            <div className="contact-wrapper-form">
                                <h4 className="contact-title pb-10 text-center text-lg-left">Leave a message</h4>
                                
                                {/* onSubmit={handleSubmit} */}
                                <form
                                    onSubmit={formik.handleSubmit} 
                                    id="contact-form"
                                    name="contact-form"
                                    data-netlify="true"
                                    data-netlify-honeypot="email_address"
                                    >
                                    {/* 
                                        action="/contact-success"
                                        method="POST"
                                    */}

                                    <p className="hidden" hidden>
                                        <label>Don&apos;t fill this out if you&apos;re human: <input name="email_address" /></label>
                                    </p>
                                    <input type="hidden" name="form-name" value="contact-form" />
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="contact-form mt-45">

                                                {/* NAME INPUT */}
                                                <input
                                                    onChange={formik.handleChange}
                                                    value={formik.values.name}
                                                    type="text"
                                                    name="name"
                                                    placeholder="Full Name" />

                                            </div> 
                                        </div>
                                        <div className="col-md-6">
                                            <div className="contact-form mt-45">

                                                {/* EMAIL INPUT */}
                                                <input 
                                                    onChange={formik.handleChange}
                                                    value={formik.values.email}
                                                    type="email"
                                                    name="email"
                                                    placeholder="Email" />

                                            </div> 
                                        </div>
                                        <div className="col-md-12">
                                            <div className="contact-form mt-45">

                                                {/* MESSAGE INPUT */}
                                                <textarea 
                                                    onChange={formik.handleChange}
                                                    value={formik.values.message}
                                                    name="message"
                                                    placeholder="Message...">
                                                </textarea>

                                            </div> 
                                        </div>
                                        <div className="col-md-12 my-3 flex-row-cen">
                                            <input type="checkbox" id="accept" value={hasAccepted} onChange={handleAcceptedChange} />
                                            <label className="ml-4 small" htmlFor="accept">I have read and acknowledged the <Link className="contact--privacy-link" to="/privacy">Privacy policy</Link>.</label>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="contact-form mt-2 d-flex">
                                                <button
                                                    disabled={ hasAccepted && formik.isValid ? false : true } 
                                                    style={ hasAccepted && formik.isValid ? {} : disabledStyle } 
                                                    type="submit"
                                                    className="lexiqa-bg-green text-white main-btn btn-primary">Send Message</button>
                                            </div> 
                                        </div>
                                    </div> 
                                </form>
                                { response.show 
                                    && 
                                    <div className="email-response">
                                        <button className={ "btn py-3 pl-5 btn-" + response.class } onClick={()=> setResponse({ ...response, show: false }) }>
                                            <span className="mr-4">{ response.message } </span>
                                            <span className="ml-4 pr-2 email-response--close">&times;</span>
                                        </button>
                                    </div>
                                }
                            </div> 
                        </div>
                    </div> 
                </div> 
            </section>

            {/* <!--====== CONTACT PART ENDS ======--> */}

            {/* <!--====== NEWSLETTER PART START ======--> */}
    
            <section className="newsletter-area bg_cover pt-115 pb-120 bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="newsletter-wrapper">
                                <div className="section-title text-center">
                                    <h6 className="sub-title lexiqa-green">NEWSLETTER</h6>
                                    <h4 className="title">Get updated for every new article</h4>
                                </div>
                                <div className="newsletter-form">
                                    <form
                                        onSubmit={newsLetterFormik.handleSubmit} 
                                        id="newsletter-form"
                                        name="newsletter-form"
                                        data-netlify="true"
                                        data-netlify-honeypot="email_address"
                                    >
                                        <p className="hidden" hidden>
                                            <label>Don&apos;t fill this out if you&apos;re human: <input name="email_address" /></label>
                                        </p>
                                        <input 
                                            onChange={newsLetterFormik.handleChange} 
                                            value={newsLetterFormik.values.email} 
                                            type="email" 
                                            name="email" 
                                            className="lexiqa-border-green"
                                            placeholder="Enter your Email" 
                                        />
                                        <button 
                                            type="submit"
                                            disabled={ newsLetterFormik.isValid && !newsLetterFormik.isDirty ? false : true }
                                            className="main-btn lexiqa-bg-green" 
                                            style={{ border: "none" }}
                                        >
                                            Subscribe
                                        </button>
                                    </form>
                                </div>
                            </div> 
                        </div>
                    </div> 
                </div>
            </section>
            
            {/* <!--====== NEWSLETTER PART ENDS ======--> */}

            <Footer />
        </PageWrapper>
    )
}

export default ContactIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`
